/**
 * Validates a Kazakhstan IIN or BIN (12 digits + checksum).
 */
export function validateIinBin(value) {
  const iinBin = String(value || '').trim();

  if (!/^\d{12}$/.test(iinBin)) return false;

  const digits = iinBin.split('').map(Number);
  const coeff1 = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11];
  const coeff2 = [3, 4, 5, 6, 7, 8, 9, 10, 11, 1, 2];

  const calcChecksum = (coeffs) =>
    digits.slice(0, 11).reduce((sum, d, i) => sum + d * coeffs[i], 0) % 11;

  let checksum = calcChecksum(coeff1);
  if (checksum === 10) checksum = calcChecksum(coeff2);
  if (checksum === 10) return false;

  return checksum === digits[11];
}
